import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32a11cb2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=32a11cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsCard: require('/opt/iaravia.ru/src/components/news-card.vue').default,SuluTemplateNewsList: require('/opt/iaravia.ru/node_modules/@razlet/sulu-sdk/src/components/template/news-list.vue').default,Sulu: require('/opt/iaravia.ru/node_modules/@razlet/sulu-sdk/src/components/index.vue').default})
